import React from 'react';
import { Phone, PhoneOff } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

function initialsFromName(name) {
  return String(name || '')
    .split(' ')
    .filter(Boolean)
    .map((p) => p[0] || '')
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

export function IncomingCallPopup({
  callerName = 'Nxënës Gjermanisht',
  callerProfession = 'Bisedë Gjuhësore',
  avatarUrl = null,
  isGroup = false,
  groupTitle = null,
  onAccept,
  onReject,
}) {
  const displayName = callerName || 'Telefonatë Hyrëse';

  return (
    <>
      {/* Mobile Backdrop */}
      <div
        className="fixed inset-0 z-[199] bg-black animate-in fade-in duration-300 sm:hidden"
        aria-hidden
      />

      {/* Floating Card */}
      <div
        className={cn(
          'fixed z-[200] w-[calc(100vw-1.5rem)] animate-in slide-in-from-bottom-3 fade-in duration-300',
          'bottom-[max(0.75rem,env(safe-area-inset-bottom))] left-1/2 -translate-x-1/2 max-w-none',
          'sm:bottom-5 sm:left-auto sm:right-5 sm:w-[min(360px,calc(100vw-2rem))] sm:max-w-[360px] sm:translate-x-0'
        )}
        role="alertdialog"
        aria-labelledby="incoming-call-title"
        aria-describedby="incoming-call-subtitle"
      >
        <div className="overflow-hidden rounded-2xl bg-white shadow-2xl shadow-black/20 backdrop-blur-md">
          <div className="flex items-start gap-3 p-3.5 sm:gap-4 sm:p-4">
            <div className="relative shrink-0">
              <span
                className="pointer-events-none absolute -inset-1 rounded-full border border-emerald-500/35 bg-emerald-500/10"
                aria-hidden
              />
              <span
                className="pointer-events-none absolute -inset-1.5 rounded-full border border-emerald-500/30 animate-ping sm:-inset-2"
                style={{ animationDuration: '2.2s' }}
                aria-hidden
              />
              <div className="relative flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-tr from-zinc-900 to-zinc-700 text-sm font-bold text-[#FFCE00] shadow-sm sm:h-14 sm:w-14 sm:text-base ring-2 ring-white">
                {avatarUrl ? (
                  <img src={avatarUrl} alt="" className="h-full w-full rounded-full object-cover" />
                ) : (
                  initialsFromName(displayName)
                )}
              </div>
            </div>

            <div className="min-w-0 flex-1 pt-0.5">
              <p
                id="incoming-call-title"
                className="truncate text-sm font-bold text-zinc-950 sm:text-[15px]"
              >
                {displayName}
              </p>
              <p
                id="incoming-call-subtitle"
                className="mt-0.5 text-xs font-medium text-emerald-600 flex items-center gap-1.5"
              >
                <span className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />
                {isGroup ? 'Thirrje në grup po bie...' : 'Thirrje hyrëse me zë / video...'}
              </p>
              {callerProfession && (
                <p className="mt-1 text-[11px] text-zinc-500 truncate">
                  {callerProfession}
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2 border-t border-zinc-100 bg-zinc-50/70 p-2.5 sm:p-3">
            <Button
              type="button"
              variant="outline"
              className="h-9 gap-1.5 rounded-xl border-red-200 bg-white text-xs font-bold text-red-600 hover:bg-red-50 hover:text-red-700 sm:h-10 sm:text-sm"
              onClick={onReject}
            >
              <PhoneOff className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              Refuzo
            </Button>
            <Button
              type="button"
              className="h-9 gap-1.5 rounded-xl bg-emerald-600 text-xs font-bold text-white shadow-sm hover:bg-emerald-700 sm:h-10 sm:text-sm"
              onClick={onAccept}
            >
              <Phone className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              Përgjigju
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default IncomingCallPopup;
